import { objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { toast as toast$1 } from 'react-toastify';
import IlInlineNotification from '../IlInlineNotification/index.js';
import '../IlToastNotification/index.js';

/**
 * Display Toast Notificaitions
 * Custom options for Notification, this represents the props that IlToastNotification | IlInlineNotification will take
 * IToast {
 *  actions?: ReactNode;
 *  hideCloseButton?: boolean;
 *  kind?: success | info | warning | error;
 *  notificationType: inline | toast;
 *  onCloseButtonClick?: (e: React.MouseEvent<HTMLButtonElement>) => void,
 *  subtitle?: ReactNode,
 *  title: ReactNode,
 *}
 * @param { IToast | string } content as string it will take default options
 * IToastOptions {
 *  position?: top-right | top-center | top-left | top-right | top-center | top-left;
 *  autoClose?: boolean | number;
 *  closeButton?: React.ReactNode | boolean;
 *  hideProgressBar?: boolean,
 *  pauseOnHover?: boolean,
 *  closeOnClick?: boolean,
 *  newestOnTop?: boolean,
 *  className?: string,
 *  style?: object,
 *  toastClassName?: string,
 *  bodyClassName?: string,
 *  progressClassName?: string,
 *  progressStyle?: object,
 *  transition?: () => void,
 *  rtl?: boolean,
 *  draggable?: boolean,
 *  draggablePercent?: number,
 *  pauseOnFocusLoss?: boolean,
 *  enableMultiContainer?: boolean,
 *  containerId?: string | number,
 *  role?: string,
 *  onClick?: () => void,
 *  onOpen?: <T = {}>(props: T) => void;
 *  onClose?: <T = {}>(props: T) => void;
 *  toastId?: string | number;
 *  updateId?: string | number;
 *  progress?: number | string;
 *  delay?: number;
 * }
 * @param { IToastOptions } options custom options for this specific toast
 */
function toast(content, options) {
  var contentProps = _objectSpread2({
    withToastify: true
  }, content);
  if (typeof content === 'string') {
    toast$1(function () {
      return /*#__PURE__*/React__default.createElement(IlInlineNotification, {
        withToastify: true,
        notificationType: "inline",
        title: content
      });
    }, options);
  }
  if (content && content.title) {
    var caption = content.caption;
    toast$1(function () {
      return /*#__PURE__*/React__default.createElement(IlInlineNotification, _extends({
        actions: caption
      }, contentProps));
    }, options);
  }
}
var dismiss = toast$1.dismiss,
  clearWaitingQueue = toast$1.clearWaitingQueue,
  isActive = toast$1.isActive,
  update = toast$1.update,
  done = toast$1.done,
  onChange = toast$1.onChange,
  configure = toast$1.configure;
toast.dismiss = dismiss;
toast.clearWaitingQueue = clearWaitingQueue;
toast.isActive = isActive;
toast.update = update;
toast.done = done;
toast.onChange = onChange;
toast.configure = configure;

export { toast as default };
